export default __webpack_public_path__ + "static/media/place-24.2f342a18.svg";